import AuthRoutes from "./Auth";
import GuestRoutes from "./Guest";

const DefaultRoute = "/";
const GuestRouteURL = "/login";

/**
 ** Route Common Format
 * Note: add auth related route in AuthRoues. Location: ./Auth.js
 * Note: add guest route in GuestRoues. Location: ./Guest.js. Guest does not need any kinds of permission.
    For a single route
    {
        path: "/profile",
        async lazy() {
            const component = await import(
                "../../pages/userManagement/profile/UserProfile"
            );
            return {
                Component: component.default,
            };
        },
        exact: true,
        permissions: [
            "profile-view",
            "profile-edit",
        ],
    },

    For neseted route/children
    {
        path: "trip-route",
        exact: true,
        permissions: [
            "trip-route-list",
            "trip-route-create",
            "trip-route-edit",
            "trip-route-delete",
        ],
        children: [
            {
                index: true,
                async lazy() {
                    const component = await import(
                        "../../pages/TripRoute/List"
                    );
                    return {
                        Component: component.default,
                    };
                },
            },
            {
                path: "create",
                async lazy() {
                    const component = await import(
                        "../../pages/TripRoute/Upsert"
                    );
                    return {
                        Component: component.default,
                    };
                },
                exact: true,
                permissions: ["trip-route-create"],
            },
        ]
    }
 */

export { DefaultRoute, GuestRouteURL, GuestRoutes, AuthRoutes };
